<div class="projectable-form-wrapper"
  (keyup.enter)="save($event)"
  (keyup.escape)="closeModal(false)"
  [class.projectable-form-hidden]="!dataInit"
  >
  <lib-form-header
    [data]="formData"
    [title]="formData.id ? 'Edit Identity: ' : 'Create New Identity'"
    [moreActions]="moreActions"
    [multiActions]="multiActions"
    (actionRequested)="headerActionRequested($event)"
    (multiActionRequested)="multiActionRequested($event)"
    [(formView)]="formView"
    [class.is-scrolled]="isScrolled"
    [saveDisabled]="formPermissionSaveDisabled"
    [saveTooltip]="formPermissionSaveTooltip"
    [strictReadonlyUi]="useStrictReadonlyForm"
  ></lib-form-header>
  <ng-content select="[slot=tabs-slot]"></ng-content>
  <div class="identity-form-container projectable-form-container" #formContainer>
    @if (formView === 'simple') {
      <div class="projectable-form-main-column form-group-row">
        <div class="form-group-column three-fifths">
          <lib-form-field-container [title]="'Identity Name'" [label]="useStrictReadonlyForm ? '' : 'REQUIRED'">
              <input
                class="form-field-input"
                placeholder="Name this identity"
                [ngClass]="{error: errors['name']}"
                [(ngModel)]="formData.name"
                autofocus
                #nameFieldInput
                [disabled]="useStrictReadonlyForm"
                />
          </lib-form-field-container>
          <lib-form-field-container
            [title]="'Select or create Identity attributes'"
            [label]="useStrictReadonlyForm ? '' : 'OPTIONAL'"
            [contentStyle]="'z-index: 99999999'"
            [helpText]="'Attributes are tags applied to an resource. Apply the same tag to other Identities to form a group of Identities.'"
            >
            <lib-tag-selector
              [(selectedRoleAttributes)]="formData.roleAttributes"
              (selectedRoleAttributesChange)="roleAttributesChanged($event)"
              [availableRoleAttributes]="identityRoleAttributes"
              [placeholder]="'Add attributes to group Identities'"
              [disableField]="useStrictReadonlyForm"
              [disableCreate]="useStrictReadonlyForm"
            ></lib-tag-selector>
          </lib-form-field-container>
          <ng-content select="[slot=column-1-slot-1]"></ng-content>
          @if (canReadRelated('auth-policies')) {
          <lib-form-field-container
            [title]="'Auth Policy'"
            [label]="useStrictReadonlyForm ? '' : 'OPTIONAL'"
            [helpText]="'Authentication Policies restrict the authentication methods available to identities.'"
            >
            <select
              [(ngModel)]="formData.authPolicyId"
              id="authPolicyId"
              class="form-field-dropdown"
              [disabled]="useStrictReadonlyForm"
              >
              <option value="">Select an Authentication Policy</option>
              @for (policy of authPolicies; track policy) {
                <option
                  [value]="policy.id"
                  >
                  {{ policy.name }}
                </option>
              }
            </select>
            <div class="form-field-label-container" style="gap: var(--paddingMedium)">
              <div class="form-field-header">
                <div class="form-field-title-container">
                  <span class="form-field-title">External ID</span>
                </div>
                <span class="form-field-label">{{ useStrictReadonlyForm ? '' : 'OPTIONAL' }}</span>
              </div>
              <input
                class="form-field-input"
                placeholder="Optional External ID"
                [(ngModel)]="formData.externalId"
                [disabled]="useStrictReadonlyForm"
                />
            </div>
          </lib-form-field-container>
          }
          <ng-content select="[slot=column-1-slot-2]"></ng-content>
          <lib-form-field-toggle [(toggleOn)]="showMore" (toggleOnChange)="showMoreChanged($event)" style="margin: 0px 10px"></lib-form-field-toggle>
          <div [hidden]="!showMore" class="form-group-column">
            <lib-form-field-container
              [title]="'Enrollment Type'"
              [title2]="enrollmentTypeTitle"
              [layout]="'row'"
              class="form-field-advanced"
              >
              <select
                id="EnrollmentType"
                class="form-field-dropdown"
                [ngClass]="{disabled: isEditing}"
                [disabled]="useStrictReadonlyForm || isEditing"
                [(ngModel)]="enrollmentType"
                (change)="updateEnrollment()"
                >
                <option value="ott">One Time Token</option>
                <option value="CA" [hidden]="!canReadRelated('cas')">Certificate Authority</option>
                <option value="updb">UPDB</option>
                <option value="none">None</option>
              </select>
              @if (enrollmentType === 'CA' && canReadRelated('cas')) {
                <select
                  id="CertAuthorities"
                  class="form-field-dropdown"
                  [ngClass]="{disabled: isEditing, error: errors.enrollmentCA}"
                  [disabled]="useStrictReadonlyForm || isEditing"
                  [(ngModel)]="enrollmentCA"
                  (change)="updateEnrollment()"
                  >
                  @for (ca of cas; track ca) {
                    <option [value]="ca.id">{{ca.name}}</option>
                  }
                </select>
              }
              @if (enrollmentType === 'updb' && !isEditing) {
                <input
                  id="UPDBName"
                  class="form-field-input"
                  [ngClass]="{disabled: isEditing, error: errors.enrollmentUPDB}"
                  [(ngModel)]="enrollmentUPDB"
                  (keyup)="updateEnrollment()"
                  type="text"
                  maxlength="500"
                  placeholder="Enter a name"
                  [disabled]="useStrictReadonlyForm"
                  >
              }
            </lib-form-field-container>
            <lib-form-field-container
              [title]="'Admin'"
              [layout]="'row'"
              class="form-field-advanced is-admin-container"
              >
              <div class="config-item">
                <div class="config-container toggle-container">
                  <div class="config-container-label">IS ADMIN</div>
                  <div
                    (click)="toggleIsAdmin()"
                    [ngClass]="{ on: formData.isAdmin, 'toggle-readonly': useStrictReadonlyForm }"
                    class="toggle"
                    >
                    <span [hidden]="!formData.isAdmin" class="on-label">YES</span>
                    <span [hidden]="formData.isAdmin" class="off-label">NO</span>
                    <div class="switch"></div>
                  </div>
                </div>
              </div>
            </lib-form-field-container>
            <lib-form-field-container
              [title]="'Hosting Cost'"
              [title2]="'Precedence'"
              [layout]="'row'"
              class="form-field-advanced"
              >
              <input
                class="form-field-input"
                [(ngModel)]="formData.defaultHostingCost"
                type="number"
                [disabled]="useStrictReadonlyForm"
                />
              <select
                [(ngModel)]="formData.defaultHostingPrecedence"
                id="hostingPrecedence"
                class="form-field-dropdown"
                [disabled]="useStrictReadonlyForm"
                >
                <option value="default">Default</option>
                <option value="required">Required</option>
                <option value="failed">Failed</option>
              </select>
            </lib-form-field-container>
            @for (tagElement of tagElements; track tagElement) {
              <lib-form-field-container
                [title]="tagElement.label"
                [label]="useStrictReadonlyForm ? '' : 'OPTIONAL'"
                class="form-field-advanced"
                >
                <div [innerHTML]="tagElement.content | safe"></div>
              </lib-form-field-container>
            }
            @if (!hideTags) {
              <lib-form-field-container
                [title]="'Custom Tags'"
                [label]="useStrictReadonlyForm ? '' : 'OPTIONAL'"
                class="form-field-advanced"
                >
                <lib-custom-tags [(tags)]="formData.tags" [readOnly]="useStrictReadonlyForm"></lib-custom-tags>
              </lib-form-field-container>
            }
            <lib-form-field-container
              [title]="'App Data'"
              [label]="useStrictReadonlyForm ? '' : 'OPTIONAL'"
              class="form-field-advanced"
              >
              <lib-json-view [(data)]="formData.appData" [readOnly]="useStrictReadonlyForm"></lib-json-view>
            </lib-form-field-container>
          </div>
        </div>
        <div class="form-group-column two-fifths">
          <ng-content select="[slot=column-2-slot-1]"></ng-content>
          @if (isEdit && (hasEnrolmentToken || hasAuthenticator)) {
            <lib-form-field-container
              [showHeader]="false"
              [layout]="'column'"
              [contentStyle]="'z-index: 99999999'"
              >
              <div class="form-field-label-container" style="gap: var(--paddingMedium)">
                <div class="form-field-header">
                  <div class="form-field-title-container">
                    <span class="form-field-title">Enrollment:</span>
                  </div>
                  @if (jwtExpired !== undefined && !showResetToken) {
                    <span class="form-field-label info-text"
                      [class.expired-text]="jwtExpired"
                      >
                      {{jwtExpired ? 'EXPIRED' : 'EXPIRES'}} {{expirationDate}}
                    </span>
                  }
                </div>
                @if (!useStrictReadonlyForm) {
                <lib-qr-code
                  [identity]="formData"
                  [jwt]="jwt"
                  [expiration]="enrollmentExpiration"
                  [authenticators]="formData.authenticators"
                  [type]="'identity'"
                  [canExpand]="true"
                  (doRefresh)="refreshIdentity(true)"
                ></lib-qr-code>
                }
              </div>
            </lib-form-field-container>
          }
          @if (isEdit && !useStrictReadonlyForm) {
            <lib-form-field-container
              [showHeader]="false"
              [layout]="'column'"
              [contentStyle]="'z-index: 99999999'"
              >
              <div class="form-field-label-container" style="gap: var(--paddingMedium)">
                <div class="form-field-header">
                  <div class="form-field-title-container">
                    <span class="form-field-title">Enable / Disable:</span>
                  </div>
                </div>
                @if (entityDisabled) {
                  <div class="disable-identity-button-container" (click)="enableIdentity()">
                    <div class="disable-identity-background"></div>
                    <button class="download-button disable-identity-button">Enable Identity</button>
                  </div>
                }
                @if (!entityDisabled) {
                  <div class="disable-identity-button-container" (click)="disableIdentity()">
                    <div class="disable-identity-background"></div>
                    <button class="download-button disable-identity-button">Disable Identity</button>
                  </div>
                }
              </div>
              @if (!entityDisabled) {
                <div class="form-field-label-container" style="gap: var(--paddingMedium)">
                  <div class="form-field-header">
                    <div class="form-field-title-container">
                      <span class="form-field-title">Disable Until:</span>
                    </div>
                  </div>
                  <div class="disable-identity-duration-container">
                    <select [(ngModel)]="disableDurationType" id="DurationType" class="form-field-dropdown">
                      <option value="indefinite">Indefinite</option>
                      <option value="pick-date">Pick a Date & Time</option>
                    </select>
                    @if (disableDurationType === 'pick-date') {
                      <div class="disable-identity-datetime-inputs">
                        <lib-date-time-picker
                          class="disable-identity-date-time-picker"
                          [(ngModel)]="disableDuration"
                          [minDate]="minDate"
                          [closeOnDateSelect]="true"
                        ></lib-date-time-picker>
                      </div>
                    }
                  </div>
                </div>
              }
            </lib-form-field-container>
          }
          @if (formData.id && canReadRelated('services')) {
            <lib-form-field-container
              [title]="'Associated Services'"
              [count]="associatedServices.length"
              [class]="'hide-overflow'"
              [helpText]="'Preview list of all services that this Identity is associated with.'"
              >
              <lib-preview-list
                (itemSelected)="serviceSelected($event)"
                [clickable]="true"
                [isLoading]="servicesLoading"
                [allNames]="associatedServiceNames"
              ></lib-preview-list>
              <div class="svc-test-result" [ngClass]="{'test-result-open': testResultOpen}">
                <div class="close icon-close" (click)="closeTestResult()"></div>
                <div class="result-container" [innerHTML]="testResult" ></div>
              </div>
            </lib-form-field-container>
          }
          @if (formData.id && canReadRelated('service-policies')) {
            <lib-form-field-container
              [title]="'Associated Service Policies'"
              [count]="associatedServicePolicies.length"
              [helpText]="'Preview list of all service policies that this Identity is associated with.'"
              >
              <lib-preview-list
                (itemSelected)="serviceSelected($event)"
                [clickable]="false"
                [isLoading]="servicePoliciesLoading"
                [allNames]="associatedServicePolicyNames"
              ></lib-preview-list>
            </lib-form-field-container>
          }
          @if (showApiCalls) {
            <lib-form-field-container
              [title]="'API Calls'"
              [label]="''"
              >
              <div class="form-row">
                <input class="form-field-input" [value]="apiCallURL" readonly/>
                <div class="url-copy icon-copy copy-text" (click)="copyToClipboard(apiCallURL)"></div>
              </div>
              @if (formData) {
                <lib-json-view [(data)]="apiData" [readOnly]="true" [showCopy]="true"></lib-json-view>
              }
            </lib-form-field-container>
          }
        </div>
      </div>
    }
    @if (formView === 'raw') {
      <div class="form-group-column">
        @if (formData) {
          <lib-json-view [(data)]="formData" [readOnly]="useStrictReadonlyForm"></lib-json-view>
        }
      </div>
    }
  </div>
</div>
@if (isLoading || !dataInit) {
  <lib-loading-indicator [isLoading]="isLoading || !dataInit"></lib-loading-indicator>
}
